import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import pdfIcon from '../../../images/page_white_acrobat.png'

const propTypes = {
  name: PropTypes.string,
  teReoName: PropTypes.string,
  description: PropTypes.string,
  contactEmail: PropTypes.string,
  pdfName: PropTypes.string,
  pdfLink: PropTypes.string,
};

export default function Organisation(props: InferProps<typeof propTypes>): JSX.Element {
  const {
    name,
    teReoName,
    description,
    contactEmail,
    pdfName,
    pdfLink,
  } = props;

  const derivedName = `${teReoName ? teReoName : ''}${(teReoName && name) ? ' - ' : ''}${name ? name : ''}`

  return (
    <div className="organisation">
      <Row>
        <Row>
          <Col className="organisation__name">{derivedName}</Col>
        </Row>
        <Row>
          <Col className="organisation__description">{description}</Col>
        </Row>
        <Row>
          <Col xs={12} md={6} className="organisation__contact">
            {contactEmail &&
            <p>Contact: <a href={`mailto: ${contactEmail}`}>{contactEmail}</a></p>}
          </Col>
          {(pdfLink && pdfName) &&
            <Col xs={12} md={6} className="organisation__link">
              Further info: <img src={pdfIcon} className="pdf-icon" /><a href={pdfLink} rel='noreferrer noopener' target='_blank'>{pdfName}</a>
            </Col>
          }
        </Row>
      </Row>
      <div className='spacer'></div>
    </div>
  );
}
